import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const About = () => {
  const { page } = useSelector((state) => state.data);
  const history = useHistory();
  const handleSubmit = (e) => {
    const link = e.target.closest("a.learn-more");
    if (link) {
      e.preventDefault();
      history.push("/about");
      window.scrollTo(0, 0);
    }
  };

  const [featuresContent, setFeaturesContent] = useState("");
  useEffect(() => {
    if (page?.data?.aboutus) {
      const { htmlContent, siteId } = page.data.aboutus;

      if (siteId === 2 && htmlContent) {
        // Decode HTML entities using DOMParser
        const parser = new DOMParser();
        const decodedDocument = parser.parseFromString(
          htmlContent,
          "text/html"
        );
        const decoded = decodedDocument.documentElement.textContent;

        setFeaturesContent(decoded);
      }
    }
  }, [page]);

  return (
    <div onClick={handleSubmit} id="rs-about">
      <div dangerouslySetInnerHTML={{ __html: featuresContent }} />
    </div>
  );
};

export default About;
